

interface StatusBadgeProps {
  status: string;
  type: 'certificate' | 'deployment' | 'environment';
  size?: 'sm' | 'md' | 'lg';
}

export function StatusBadge({ status, type, size = 'md' }: StatusBadgeProps): JSX.Element {
  const getStatusClass = (status: string, type: string): string => {
    const normalizedStatus = status.toLowerCase();
    
    switch (type) {
      case 'certificate':
        switch (normalizedStatus) {
          case 'active':
          case 'valid':
            return 'badge-success';
          case 'expired':
          case 'revoked':
            return 'badge-danger';
          case 'expiring':
          case 'warning':
            return 'badge-warning';
          case 'pending':
            return 'badge-info';
          default:
            return 'badge-secondary';
        }
      
      case 'deployment':
        switch (normalizedStatus) {
          case 'deployed':
          case 'successful':
          case 'success':
            return 'badge-success';
          case 'failed':
          case 'error':
            return 'badge-danger';
          case 'pending':
          case 'deploying':
            return 'badge-warning';
          case 'removed':
            return 'badge-secondary';
          default:
            return 'badge-info';
        }
      
      case 'environment':
        switch (normalizedStatus) {
          case 'active':
          case 'healthy':
            return 'badge-success';
          case 'inactive':
          case 'unhealthy':
            return 'badge-danger';
          case 'maintenance':
            return 'badge-warning';
          default:
            return 'badge-info';
        }
      
      default:
        return 'badge-secondary';
    }
  };

  const getSizeClass = (size: string): string => {
    switch (size) {
      case 'sm':
        return 'badge-sm';
      case 'lg':
        return 'badge-lg';
      default:
        return '';
    }
  };

  const badgeClass = `badge ${getStatusClass(status, type)} ${getSizeClass(size)}`.trim();

  return (
    <span className={badgeClass}>
      {status}
    </span>
  );
}